import { getServerNow } from "@/services/publicAuthConfigService";

const MILLISECOND_TIMESTAMP_MIN = 100000000000;
const SECOND_TIMESTAMP_MIN = 1000000000;
const YEAR_MIN = 1000;
const YEAR_MAX = 9999;

export const toPersianDigits = (value) => {
  const digits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return String(value).replace(/[0-9]/g, (digit) => digits[Number(digit)]);
};

export const isLiveStartDateValue = (value) => {
  if (value === null || value === undefined || value === "") return false;

  if (typeof value === "number") {
    if (value >= YEAR_MIN && value <= YEAR_MAX) return false;
    return value >= SECOND_TIMESTAMP_MIN;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return false;
    if (/^\d{4}$/.test(trimmed)) return false;
    if (/^\d+$/.test(trimmed)) return Number(trimmed) >= SECOND_TIMESTAMP_MIN;
    return Number.isFinite(Date.parse(trimmed));
  }

  return value instanceof Date && Number.isFinite(value.getTime());
};

export const normalizeLiveStartTimestamp = (value) => {
  if (!isLiveStartDateValue(value)) return null;

  if (value instanceof Date) return value.getTime();

  if (typeof value === "string" && !/^\d+$/.test(value.trim())) {
    return Date.parse(value);
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return null;

  return numericValue < MILLISECOND_TIMESTAMP_MIN
    ? numericValue * 1000
    : numericValue;
};

export const getLiveStartTimestamp = (content = {}) =>
  normalizeLiveStartTimestamp(
    content?.liveInfo?.liveStartDate ??
      content?.liveStartDate ??
      content?.startDate ??
      content?.year,
  );

export const getCountdownParts = (targetTimestamp, now = getServerNow()) => {
  const difference = targetTimestamp - now;
  if (!Number.isFinite(difference) || difference <= 0) return null;

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / (1000 * 60)) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };
};

export const formatMinimalCountdown = (timeLeft) => {
  if (!timeLeft) return "";

  const pad = (value) => String(value).padStart(2, "0");
  const formatted =
    timeLeft.days > 0
      ? `${timeLeft.days}:${pad(timeLeft.hours)}:${pad(timeLeft.minutes)}:${pad(timeLeft.seconds)}`
      : `${pad(timeLeft.hours)}:${pad(timeLeft.minutes)}:${pad(timeLeft.seconds)}`;

  return toPersianDigits(formatted);
};
